/**
 * Copyright (c) Qwoach LLC 2025. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 17.09.25
 *
 */
import BaseObject from "@shared/BaseObject.js";

export default class TimeIndexData extends BaseObject {

	activeItems = []
	nextActiveItem = []
	isNextActiveItemFetched: boolean = false
	hiddenActiveItemsNumber: number = 0

	constructor({activeItems = [], nextActiveItem = [], isNextActiveItemFetched = false} = {}) {
		super();

		this.activeItems = activeItems;
		this.nextActiveItem = nextActiveItem;
		this.isNextActiveItemFetched = isNextActiveItemFetched;
	}

}
